import { takeEvery, take, put, select } from 'redux-saga/effects';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';
import { consts as postList } from './postsList';
import { consts as postDetails } from './postDetails';

export const consts = createReqConsts('communities', 'dislikePost');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'posts',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      selector: ['postId'],
    },
    'like',
  ],
});

export default createReqReducer(consts);

function* postDislikedWorker(action) {
  const { payload } = action;
  const currentPostDetailsId = yield select(
    state => state.communities.postDetails.id,
  );

  yield take(consts.SUCCEED);
  yield put({
    type: postList.POST_LIKE_CHANGED,
    payload: {
      liked: false,
      postId: payload.postId,
    },
  });
  if (payload.postId === currentPostDetailsId) {
    yield put({
      type: postDetails.DISLIKE,
    });
  }
}

export function* postDislikedSaga() {
  yield takeEvery(consts.SEND, postDislikedWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/dislikePost.js